// extracted by mini-css-extract-plugin
export var boxItems = "_b7-1";
export var boxItemsLg = "_b7-2";
export var button = "_b7-7";
export var buttonHoverless = "_b7-9";
export var buttonLg = "_b7-8";
export var filterGroupBox = "_b7-0";
export var icon = "_b7-3";
export var iconSecondary = "_b7-6";
export var iconWrapper = "_b7-4";
export var iconWrapperLg = "_b7-5";
export var truncatedLabel = "_b7-a";